<template>
  <div style="padding: 20px;">
    <h3>饲养信息</h3>
    <br>
    <a-form :form="form" labelAlign="left" >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="饲养品种">
            <a-input
              placeholder="请输入"
              v-decorator="['feedVariety',{rules: [{ required: true, message: '请输入饲养品种' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料品牌">
            <a-select
              placeholder="请选择"
              v-decorator="['feedBrand',{
                rules:[{required: true, message: '请选择饲料品牌'}],
                initialValue:`新希望`
              }]"
              @change="handleChange"
            >
              <a-select-option v-for="el in feedBrandList" :key="el.varietyDepotCode" :value="el.varietyDepotName">
                {{ el.varietyDepotName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="产品名称" >
            <a 
              v-if="form.getFieldValue('feedBrand') == '新希望' && !form.getFieldValue('productName')" 
              v-decorator="['productName',{rules:[{required: true, message: '请选择配方'}],}]"
              @click="handleClick()">选择配方</a>
            <a 
              v-else-if="form.getFieldValue('feedBrand') == '新希望' && form.getFieldValue('productName')" 
              v-decorator="['productName',{rules:[{required: true, message:'请选择配方'}],}]"
              @click="handleClick()">{{form.getFieldValue('productName')}}</a>
            <a-input 
              v-else placeholder="请输入" 
              :maxLength="50"
              v-decorator="['productName',{rules:[{required: true, message: '请输入饲料型号'}],}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="饲料终端价格（元/kg）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="300"
              v-decorator="['feedPrice',{rules:[{required: true, message: '请输入饲料终端价格'}],}]"
              :precision="2"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="入栏数量（只）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="1000000"
              @blur="verificationLegal('intoNum')"
              v-decorator="['intoNum',{rules:[{required: true, message: '请输入入栏数量'}],}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="死淘数量（只）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="1000000"
              @blur="verificationLegal('dieNum')"
              v-decorator="['dieNum',{rules:[{required: true, message: '请输入死淘数量'}],}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="开始日龄（天）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="300"
              v-decorator="['intoDayAge',{rules:[{required: true, message: '请输入开始日龄'}],}]"
              :precision="2"
              @blur="verificationLegal('intoDayAge')"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="结束日龄（天）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="1000"
              v-decorator="['outDayAge',{rules:[{required: true, message: '请输入结束日龄'}],}]"
              :precision="2"
              @blur="verificationLegal('outDayAge')"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="出栏体重（斤/只）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="300"
              v-decorator="['outWeight',{rules:[{required: true, message: '请输入出栏体重'}],}]"
              :precision="2"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="阶段总产蛋数（枚）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="100000000"
              v-decorator="['totalEggNum',{rules:[{required: true, message: '请输入阶段总产蛋数'}],}]"
              :precision="2"
              @blur="verificationLegal('totalEggNum')"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="阶段总产蛋量（斤）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="100000000"
              v-decorator="['totalEggWeight',{rules:[{required: true, message: '请输入阶段总产蛋量'}],}]"
              :precision="2"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="不合格蛋（枚）">
            <a-input-number
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="1000000"
              v-decorator="['substandardEggNum',{rules:[{required: true, message: '请输入不合格蛋'}],}]"
              :precision="2"
              @blur="verificationLegal('substandardEggNum')"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="阶段总耗料（斤）">
            <a-input-number 
              style="width: 100%;"
              placeholder="请输入"
              :min="1"
              :max="10000000" 
              :precision="2"
              v-decorator="['feedCost',{rules:[{required: true, message: '请输入阶段总耗料'}],}]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <formula-modal 
      ref="formulaModal" 
      :visible="visible" 
      @isShow="isShow" 
      @getSelect="getSelect" 
      :selectFactory="selectFactory"
      :factoryId="factoryId"
    />
  </div>
</template>

<script>
import {inputFeedInfoRuminateColumns} from '../Columns'
import {animalTypeList} from './Lists'
import FormulaModal from'./FormulaModal.vue'

export default {
  props:['selectFactory','factoryId','poultryLineEggFeedInfo','animalType'],
  components:{FormulaModal},
  data(){
    return{
      form: this.$form.createForm(this, { name: 'feedInfo' }),
      inputFeedInfoRuminateColumns,
      animalTypeList,
      feedBrandList:[],
      visible: false,
      nhfFormulaId:'',
      modelName:'',
      modelCode:''
    }
  },
  mounted() {
    this.feedBrandGet()
    this.form.setFieldsValue(this.poultryLineEggFeedInfo)
    this.nhfFormulaId=this.poultryLineEggFeedInfo?.nhfFormulaId
    this.modelName=this.poultryLineEggFeedInfo?.modelName
    this.modelCode=this.poultryLineEggFeedInfo?.modelCode
    // this.getFeedVarietyList()
  },
  methods:{
    sendData(){
      this.$emit('setFeedInfo', {
        nhfFormulaId:this.nhfFormulaId,
        modelName:this.modelName,
        modelCode:this.modelCode
      })
    },
    handleChange(){
      this.nhfFormulaId = ''
      this.modelName = ''
      this.modelCode = ''
      this.form.setFieldsValue({'productName':''})
    },
    handleClick() {
      this.visible = true
      this.$refs.formulaModal.reset()
    },
    isShow(val){
      this.visible = val
    },
    getSelect(val){
      this.form.setFieldsValue({'productName':val[0].formulaName})
      this.nhfFormulaId = val[0].id
      this.modelCode = val[0].modelCode
      this.modelName = val[0].modelName
    },
    async feedBrandGet() {
      const res = await this.$http.get("/sat-ruminants/varietydepot/list", {
        params:{type:2, size:-1, labelCode:'eggTypePoultry'} 
      })
      let { success, data } = res;
      if (success) {
        this.feedBrandList = data.records 
      }
    },
    verificationLegal(title) {
      if(this.form.getFieldValue('outDayAge') && this.form.getFieldValue('intoDayAge') && this.form.getFieldValue('outDayAge') < this.form.getFieldValue('intoDayAge')){
        this.$message.error('结束日龄不得小于开始日龄，请重新输入！')
        this.form.setFieldsValue({[title]:''})
      }
      if(this.form.getFieldValue('intoNum') && this.form.getFieldValue('dieNum') && this.form.getFieldValue('intoNum') < this.form.getFieldValue('dieNum')){
        this.$message.error('死淘数量不得大于入栏数量，请重新输入！')
        this.form.setFieldsValue({[title]:''})
      }
      if(this.form.getFieldValue('totalEggNum') && this.form.getFieldValue('substandardEggNum') && this.form.getFieldValue('totalEggNum') < this.form.getFieldValue('substandardEggNum')){
        this.$message.error('不合格蛋数量不得大于阶段总产蛋数量，请重新输入！')
        this.form.setFieldsValue({[title]:''})
      }
    },
    // async getFeedVarietyList(){
    //   let {VarietyDepotCode,LabelCode} = this.animalTypeList.find(
    //     item => item.name == this.animalType
    //   )
    //   let res = await this.$http.get("/sat-ruminants/animalvariety/list", { params:{VarietyDepotCode,LabelCode}})
    //   this.feedVarietyList = res.data.records
    // },
    deleteProductName(record){
      record.productName = undefined
      record.nhfFormulaId = ''
      record.modelName = ''
      record.modelCode = ''
    }
  }
}
</script>

<style>

</style>